import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import jwt_decode from "jwt-decode";
import { useAuth } from "../../../context/AuthContext";
import { fetchBranchMIS } from "../../../redux/slice/getMISSlice";
import { fetchOpsMIS } from "../../../redux/slice/getOpsMISSlice";
import { uploadOpsMIS } from "../../../redux/slice/uploadOpsMISSlice";
import { updateBranchFeedback } from "../../../redux/slice/updateBranchFeedback";
import "../../../../assets/styles/buttons.css";
import {
  Spin,
  Table,
  Card,
  Modal,
  Button,
  Input,
  Tabs,
  Upload,
  message,
  Tooltip,
  Radio,
  Alert,
  Select,
  Divider,
  Form,
  DatePicker
} from "antd";
import {
  UploadOutlined,
  LoadingOutlined,
  PlusOutlined,
  FileExcelOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { CSVLink } from "react-csv";
import * as XLSX from "xlsx";
import moment from 'moment';
import { trackFeatureAction } from "../../../analytics/googleAnalytics";

const { TextArea } = Input;

const MISComp = ({ reportType, extraProp }) => {
  const featureNameMap = {
    "DISB MIS": "Disbursement MIS",
    "UTR": "UTR Tracker",
    "DAILY STATUS": "Daily Status",
    "ACH": "ACH Status",
  };

  const featureName =
    featureNameMap[reportType] || reportType;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [selectedFile, setSelectedFile] = useState(null);
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [uploadAlert, setUploadAlert] = useState("");
  const [lastUpdatedDate, setLastUpdatedDate] = useState(null);
  const [lastUpdatedTime, setLastUpdatedTime] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [userUploadType, setUserUploadType] = useState(null);
  const [branchFieldError, setBranchFieldError] = useState(false);
  const [uploadFailedError, setUploadFailedError] = useState(false);
  const [invalidFormatError, setInvalidFormatError] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [standardRemark, setStandardRemark] = useState("");
  const [branchFeedbackValue, setBranchFeedbackValue] = useState('')
  const [otherRemark, setOtherRemark] = useState('');
  const [feedbackModalVisible, setFeedbackModalVisible] = useState(false)
  const [selectedAppID, setSelectedAppID] = useState('')
  const [followUpDate, setFollowUpDate] = useState('');
  const [submitLoading, setSubmitLoading] = useState(false);

  const { authState, onLogout } = useAuth();

  var token_decoded = authState.token;
  var jwtBearer = authState.token;
  var jwt_payload = "";
  var jwt_payload_group = [];
  var jwt_payload_expiry = [];
  var jwt_user_id = "";
  var jwt_user_name = "";
  var jwt_user = '';

  if (jwtBearer) {
    jwt_payload = jwt_decode(jwtBearer);
    jwt_payload_group = extraProp?.group_id;
    jwt_payload_expiry = jwt_payload.exp;
    jwt_user_id = jwt_payload.user_id;
    jwt_user_name = extraProp?.username;
    jwt_user = jwt_user_id + ' - ' + jwt_user_name
  }

  // Session Timeout
  const TOKEN_KEY = "my-jwt";
  var currentTime = Math.floor(Date.now() / 1000);

  if (jwt_payload_expiry.length != 0) {
    if (currentTime > jwt_payload_expiry) {
      console.log("In token expired condition");
      AsyncStorage.removeItem(TOKEN_KEY);
      onLogout();
      location.reload();
    }
  }

  // ✅ FIX: Use report-specific state from Redux
  const reportState = useSelector((state) => {
    switch(reportType) {
      case 'ACH':
        return {
          data: state.opsMIS?.achData,
          loading: state.opsMIS?.achLoading,
          error: state.opsMIS?.achError,
        };
      case 'UTR':
        return {
          data: state.opsMIS?.utrData,
          loading: state.opsMIS?.utrLoading,
          error: state.opsMIS?.utrError,
        };
      case 'DAILY STATUS':
        return {
          data: state.opsMIS?.dailyStatusData,
          loading: state.opsMIS?.dailyStatusLoading,
          error: state.opsMIS?.dailyStatusError,
        };
      case 'DISB MIS':
        return {
          data: state.opsMIS?.disbMisData,
          loading: state.opsMIS?.disbMisLoading,
          error: state.opsMIS?.disbMisError,
        };
      default:
        return { data: null, loading: false, error: null };
    }
  });

  const allFields = reportState.data?.message || [];
  const updated_date = reportState.data?.updated_date || [];
  const updated_time = reportState.data?.updated_time || [];

  // Fetch data when component mounts or reportType changes
  useEffect(() => {
    setLoading(true);
    dispatch(fetchOpsMIS({ type: reportType, jwtBearer })).finally(() => {
      setLoading(false);
    });
  }, [reportType]); // ✅ Re-fetch when reportType changes

  useEffect(() => {
    setDataSource(allFields);
    setLastUpdatedDate(updated_date);
    setLastUpdatedTime(updated_time);
  }, [allFields, updated_date, updated_time]);

  // Check for token expiry from API response
  const tokenExpired = reportState.error || "";
  if (tokenExpired == "Signature has expired.") {
    console.log("In token expired condition");
    AsyncStorage.removeItem(TOKEN_KEY);
    onLogout;
    location.reload();
  }

  const allKeys = allFields.reduce((keys, record) => {
    return keys.concat(Object.keys(record));
  }, []);

  const uniqueKeys = [...new Set(allKeys)];

  const columns = [
    ...uniqueKeys.map((key) => ({
      title: <strong>{key.toUpperCase()}</strong>,
      dataIndex: key,
      key: key,
      width: "30%",
      align: "left",
      filters: [...new Set(allFields.map((record) => record[key]))].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record[key] === value,
      filterSearch: true,
    })),
  ];

  const NOT_INTERESTED_REMARKS = [
    "ROI higher than expected",
    "Processing Fee (PF) high",
    "Better offer from competitor",
    "Requirement fulfilled",
    "Loan amount/EMI not suitable",
    "Credit/Eligibility issue",
    "Documentation/Property issue",
    "Customer not responding / Not interested",
  ];

  // Check if the ADD FEEDBACK column should be visible
  if (jwt_payload_group === "3") {
    columns.push({
      title: <strong>ADD FEEDBACK</strong>,
      key: 'addFeedback',
      width: "15%",
      align: "center",
      render: (_, record) => {
        if ((record.CURR_STATUS || '').toUpperCase() === 'READY FOR DISBURSEMENT') {
          const feedbackText = record.BRANCH_FEEDBACK ? 'Update Feedback' : 'Add Feedback';
          return (
            <Button
              className="regular-button"
              type="primary"
              onClick={() => handleAddFeedback(record)}
            >
              {feedbackText}
            </Button>
          );
        }
        return null;
      },
    });
  }

  const handleAddFeedback = (e) => {
    trackFeatureAction("MIS", featureName, "open", { context: "branch_feedback"});
    setSelectedAppID(e.APP_ID.toString());
    setFeedbackModalVisible(true)
  }

  const handleSubmitBankFeedback = async () => {
    const formattedFollowUpDate =
      followUpDate && branchFeedbackValue === 'In follow-up with the customer'
        ? moment(followUpDate).format('DD-MM-YYYY')
        : null;

    const requestBody = {
      user: jwt_user,
      application_id: selectedAppID,
      branch_feedback: branchFeedbackValue,
      standard_feedback:
        branchFeedbackValue === 'Not interested or rejected'
          ? standardRemark
          : null,
      raw_feedback: otherRemark || null,
      follow_up_date: formattedFollowUpDate,
    };

    try {
      setSubmitLoading(true);  

      const response = await dispatch(
        updateBranchFeedback({
          jwtBearer: authState.token,
          requestBody,
        })
      );

      if (response.payload.code === 200) {
        await dispatch(fetchOpsMIS({ type: reportType, jwtBearer }));

        setFeedbackModalVisible(false);
        setBranchFeedbackValue('');
        setStandardRemark('');
        setOtherRemark('');
        setFollowUpDate('');

        trackFeatureAction("MIS", featureName, "submit", { context: "branch_feedback", });

        message.success('Feedback submitted successfully');
      } else {
        message.error('Error submitting feedback');
      }
    } catch (error) {
      message.error('An error occurred while submitting feedback');
    } finally {
      setSubmitLoading(false); 
    }
  };

  const allowedExtensions = ["xlsx"];
  const handleFileChange = (info) => {
    const fileExtension = info.file.name.split(".").pop().toLowerCase();
    if (!allowedExtensions.includes(fileExtension)) {
      setInvalidFormatError(true);
      setFileList([]);
      return;
    }
    setFileList(info.fileList);
  };

  const handleUpload = async () => {
    setButtonLoading(true);
    if (fileList.length > 0) {
      const file = fileList[0].originFileObj;
      const reader = new FileReader();

      reader.onload = async (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });

          let sheetNum = 0;
          if (reportType == "DAILY STATUS") {
            sheetNum = 1;
          }

          const sheet = workbook.Sheets[workbook.SheetNames[sheetNum]];
          const excelData = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "" });

          const headers = excelData[0];
          const headersUpper = headers.map((element) => {
            return element.toUpperCase();
          });

          if (reportType === "DISB MIS") {
            const disbursalDateIndex = headersUpper.indexOf("DISBURSAL DATE");
            if (disbursalDateIndex !== -1) {
              excelData.forEach((row, rowIndex) => {
                if (rowIndex > 0) {
                  const disbursalDateValue = row[disbursalDateIndex];
                  if (typeof disbursalDateValue === "number") {
                    row[disbursalDateIndex] = XLSX.SSF.format("dd-mm-yyyy", disbursalDateValue);
                  }
                }
              });
            }
          }

          if (reportType === "DAILY STATUS") {
            if (!headersUpper.includes("BRANCH_FEEDBACK")) {
              headersUpper.push("BRANCH_FEEDBACK");
            }
            if (!headersUpper.includes("FOLLOW_UP_DATE")) {
              headersUpper.push("FOLLOW_UP_DATE");
            }
          }

          if (headersUpper.includes("BRANCH")) {
            const formattedData = excelData.slice(1).map((row) => {
              const obj = {};
              headersUpper.forEach((header, index) => {
                obj[header] = row[index];
              });
              if (reportType === "DAILY STATUS" && !obj["BRANCH_FEEDBACK"]) {
                obj["BRANCH_FEEDBACK"] = "";
              }
              if (reportType === "DAILY STATUS" && !obj["FOLLOW_UP_DATE"]) {
                obj["FOLLOW_UP_DATE"] = "";
              }
              return obj;
            });

            const jsonString = JSON.stringify(formattedData);
            const fileSizeInBytes = new Blob([jsonString]).size;
            const fileSizeInKB = fileSizeInBytes / 1024;
            const fileSizeInMB = Math.floor(fileSizeInKB / 1024);

            const chunkNumber = parseInt(fileSizeInMB + 1);
            const chunkSize = Math.ceil(formattedData.length / chunkNumber);
            const chunks = [];
            for (let i = 0; i < formattedData.length; i += chunkSize) {
              chunks.push(formattedData.slice(i, i + chunkSize));
            }

            for (let i = 0; i < chunks.length; i++) {
              const uploadType = i === 0 ? "Fresh" : "Append";
              const response = await dispatch(
                uploadOpsMIS({
                  jwt_token: authState.token,
                  type: reportType,
                  uploadType: uploadType,
                  userUploadType: userUploadType,
                  requestBody: chunks[i],
                })
              );
            }

            setBranchFieldError(false);
            setUploadFailedError(false);
            setInvalidFormatError(false);
            setUploadSuccess(true);

            trackFeatureAction(
              "MIS",
              featureName,
              "upload",
              {
                upload_type: userUploadType,
              }
            );

            await dispatch(fetchOpsMIS({ type: reportType, jwtBearer }));
            setLoading(false);
            setButtonLoading(false);
            setFileList([]);
          } else {
            setBranchFieldError(true);
            setFileList([]);
            setButtonLoading(false);
          }
        } catch (error) {
          console.error("Error:", error);
          setUploadFailedError(true);
          setFileList([]);
          setButtonLoading(false);
        }
      };

      reader.readAsArrayBuffer(file);
    }
    setUserUploadType(null);
  };

  const paginationOptions = {
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "50", "100"],
    defaultPageSize: 10,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
  };

  const customRequest = ({ file, onSuccess }) => {
    onSuccess("ok");
  };

  const onUploadTypeChange = (e) => {
    setUserUploadType(e.target.value);
  };

  const handleModalClose = () => {
    setFeedbackModalVisible(false);
    setFollowUpDate("");
    setBranchFeedbackValue("");
  };

  // Check if upload should be hidden
  const hideUpload = reportType === "UTR" ||
    jwt_payload_group == "0" ||
    jwt_payload_group == "1" ||
    jwt_payload_group == "2" ||
    jwt_payload_group == "3" ||
    jwt_payload_group == "4" ||
    jwt_payload_group == "13" ||
    jwt_payload_group == "19";

  return (
    <>
      <center>
        <div>
          {hideUpload ? null : (
            <Card
              style={{
                width: "60%",
                marginTop: "20px",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
                borderRadius: "5px",
              }}
              bordered={true}
            >
              <center>
                <div>
                  <p>
                    <strong>
                      <FileExcelOutlined /> UPLOAD {reportType} REPORT
                    </strong>
                  </p>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Upload
                      customRequest={customRequest}
                      name="avatar"
                      fileList={fileList}
                      listType="picture-card"
                      onChange={handleFileChange}
                      maxCount={1}
                      style={{ alignItems: "center" }}
                    >
                      {fileList.length === 0 && (
                        <div>
                          <UploadOutlined />
                          <div style={{ marginTop: 8 }}>Select File</div>
                        </div>
                      )}
                    </Upload>
                  </div>
                  <div>
                    <p>
                      <strong>Select upload type</strong>
                      <Tooltip
                        title={
                          <span>
                            Fresh -
                            <br />
                            Selecting fresh as upload type will delete the
                            previous data and show the new data.
                            <br /> <br />
                            Append -
                            <br />
                            Selecting append as upload type will add the new
                            data along with the old data.
                          </span>
                        }
                      >
                        <InfoCircleOutlined
                          type="question-circle"
                          style={{
                            marginLeft: "5px",
                            cursor: "pointer",
                            color: "dodgerblue",
                            fontSize: "16px",
                          }}
                        />
                      </Tooltip>
                    </p>
                    <Radio.Group
                      onChange={onUploadTypeChange}
                      value={userUploadType}
                    >
                      <Radio value={"Fresh"}>Fresh</Radio>
                      <Radio value={"Append"}>Append</Radio>
                    </Radio.Group>
                  </div>
                  <Button
                    className="regular-button"
                    style={{
                      color: "white",
                      padding: "10px 20px",
                      borderRadius: "5px",
                      display: "inline-flex",
                      alignItems: "center",
                      fontWeight: "bold",
                      marginTop: "20px",
                    }}
                    onClick={handleUpload}
                    loading={buttonLoading}
                    disabled={fileList.length === 0 || userUploadType === null}
                  >
                    Upload
                  </Button>
                  {branchFieldError === false ? null : (
                    <Alert
                      style={{
                        marginTop: "20px",
                        textAlign: "justify",
                        width: "50%",
                      }}
                      message="Error"
                      description="Branch field is missing from the excel sheet."
                      type="error"
                      showIcon
                    />
                  )}
                  {uploadFailedError === false ? null : (
                    <Alert
                      style={{
                        marginTop: "20px",
                        textAlign: "justify",
                        width: "50%",
                      }}
                      message="Error"
                      description="File Upload Failed."
                      type="error"
                      showIcon
                    />
                  )}
                  {invalidFormatError == false ? null : (
                    <Alert
                      style={{
                        marginTop: "20px",
                        textAlign: "justify",
                        width: "50%",
                      }}
                      message="Error"
                      description="Invalid file format. Allowed formats: xlsx"
                      type="error"
                      showIcon
                    />
                  )}
                  {uploadSuccess == false ? null : (
                    <Alert
                      style={{
                        marginTop: "20px",
                        textAlign: "justify",
                        width: "50%",
                      }}
                      message="Success"
                      description="File Uploaded Successfully"
                      type="success"
                      showIcon
                    />
                  )}
                  <div
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    <p>
                      <strong>Instructions to be followed -</strong>
                    </p>
                    <p>1. The extension of the file should be 'xlsx'.</p>
                    <p>
                      2. Name of one of the column of the excel file should
                      'Branch' and it should have data in either of the below
                      format - '10001-Jobner' or '10001'.
                    </p>
                    <p>
                      3. The excel sheet should not be having any formula in any
                      of the cells and cells should only have values in it.
                    </p>
                  </div>

                  {uploadAlert && (
                    <div style={{ marginTop: "10px" }}>{uploadAlert}</div>
                  )}
                </div>
              </center>
            </Card>
          )}
          <Card
            layout="horizontal"
            bordered={true}
            className="criclebox tablespace mb-24"
            title={
              <>
                {reportType} TRACKER
                {lastUpdatedDate && lastUpdatedTime && (
                  <span style={{ marginLeft: "10px", fontSize: "14px" }}>
                    <br />
                    <strong>DATE</strong> - {lastUpdatedDate} &nbsp;
                    <strong>TIME</strong> - {lastUpdatedTime} (24 HRS)
                  </span>
                )}
              </>
            }
            centered
            style={{ width: "100%", marginTop: "20px" }}
            extra={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "12px",
                }}
              >
                <CSVLink
                  className="regular-button"
                  style={{
                    color: "white",
                    padding: "10px 20px",
                    borderRadius: "5px",
                    textDecoration: "none",
                    fontWeight: "bold",
                  }}
                  data={dataSource}
                  onClick={() => trackFeatureAction("MIS", featureName, "download")}
                >
                  Download Report
                </CSVLink>
              </div>
            }
          >
            <div className="table-responsive">
              {loading ? (
                <div className="spinner-container">
                  <Spin size="large" />
                </div>
              ) : (
              <Table
                columns={columns}
                dataSource={dataSource}
                pagination={paginationOptions}
                bordered
                onChange={(pagination, filters) => {
                  const filterApplied = Object.values(filters || {}).some(
                    (value) =>
                      Array.isArray(value) && value.length > 0
                  );

                  if (filterApplied) {
                    trackFeatureAction(
                      "MIS",
                      featureName,
                      "filter"
                    );
                  }
                }}
                rowClassName={(record, index) =>
                  index % 2 === 0
                    ? "table-row-light"
                    : "table-row-dark"
                }
              />
              )}
            </div>
          </Card>
          <Modal
            style={{ height: '600px' }}
            width={800}
            visible={feedbackModalVisible}
            title={<p style={{ fontSize: '20px', fontWeight: '700', color: 'grey' }}>Branch Feedback</p>}
            footer={null}
            onCancel={handleModalClose}
          >
            <Divider style={{ borderColor: 'lightgrey' }} />
            <Form style={{ marginLeft: '10px', marginRight: '20px' }} form={form} layout="vertical">
              <Form.Item label={<strong style={{ fontSize: '20px', fontWeight: '700', color: 'grey' }}>Select Feedback</strong>}>
                <Select
                  value={branchFeedbackValue}
                  onChange={(value) => setBranchFeedbackValue(value)}
                  placeholder={<p style={{ fontSize: '18px', fontWeight: '600', borderRadius: '10px' }}>Select reason</p>}
                >
                  <Select.Option value="In follow-up with the customer"><p style={{ fontSize: '18px', fontWeight: '600', color: 'black', borderRadius: '10px' }}>In follow-up with the customer</p></Select.Option>
                  <Select.Option value="Pending due to banking"><p style={{ fontSize: '18px', fontWeight: '600', color: 'black', borderRadius: '10px' }}>Pending due to banking</p></Select.Option>
                  <Select.Option value="Pending due to a security check"><p style={{ fontSize: '18px', fontWeight: '600', color: 'black', borderRadius: '10px' }}>Pending due to a security check</p></Select.Option>
                  <Select.Option value="Follow-up Applicant/Co-Applicant"><p style={{ fontSize: '18px', fontWeight: '600', color: 'black', borderRadius: '10px' }}>Follow-up Applicant/Co-Applicant</p></Select.Option>
                  <Select.Option value="Not interested or rejected"><p style={{ fontSize: '18px', fontWeight: '600', color: 'black', borderRadius: '10px' }}>Not interested or rejected</p></Select.Option>
                  <Select.Option value="Disbursed"><p style={{ fontSize: '18px', fontWeight: '600', color: 'black', borderRadius: '10px' }}>Disbursed</p></Select.Option>
                  <Select.Option value="other"><p style={{ fontSize: '18px', fontWeight: '600', color: 'black', borderRadius: '10px' }}>Other</p></Select.Option>
                </Select>
              </Form.Item>

              {branchFeedbackValue === 'other' && (
                <Form.Item>
                  <TextArea
                    rows={4}
                    value={otherRemark}
                    onChange={(e) => setOtherRemark(e.target.value)}
                    placeholder="Enter your feedback"
                  />
                </Form.Item>
              )}

              {branchFeedbackValue === "Not interested or rejected" && (
                <Form.Item
                  label={<strong>Standard Remark</strong>}
                  required
                  validateStatus={!standardRemark ? "error" : ""}
                  help={!standardRemark ? "Please select a rejection reason" : ""}
                >
                  <Select
                    placeholder="Select rejection reason"
                    value={standardRemark}
                    onChange={setStandardRemark}
                  >
                    {NOT_INTERESTED_REMARKS.map((remark) => (
                      <Select.Option key={remark} value={remark}>
                        {remark}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}

              {branchFeedbackValue === "Not interested or rejected" && (
                <Form.Item label="Branch Feedback (optional)">
                  <TextArea
                    rows={3}
                    value={otherRemark}
                    onChange={(e) => setOtherRemark(e.target.value)}
                    placeholder="Additional remarks (if any)"
                  />
                </Form.Item>
              )}

              {branchFeedbackValue === 'In follow-up with the customer' && (
                <Form.Item 
                  label={<strong style={{ fontSize: '20px', fontWeight: '700', color: 'grey' }}>Follow-up Date</strong>} 
                  name="followUpDate"
                >
                  <DatePicker
                    value={followUpDate}
                    onChange={(date) => setFollowUpDate(date?.toString())}
                    style={{ width: '100%' }}
                    placeholder="Select a date"
                    disabledDate={(current) => current && current < moment().startOf('day')}
                  />
                </Form.Item>
              )}

              {(branchFeedbackValue !== 'other' || (branchFeedbackValue === 'other' && otherRemark)) && (
                branchFeedbackValue !== 'In follow-up with the customer' || followUpDate ? (
                  <Button
                    className="regular-button"
                    type="primary"
                    loading={submitLoading}
                    disabled={
                      submitLoading ||
                      (branchFeedbackValue === 'Not interested or rejected' && !standardRemark)
                    }
                    onClick={handleSubmitBankFeedback}
                  >
                    Submit Feedback
                  </Button>
                ) : null
              )}
            </Form>
          </Modal>
        </div>
      </center>
    </>
  );
};

export default MISComp;